export default "__VITE_ASSET__9ce2ba7a__"